import request from './request'

export function artistPageApi(params) {
  return request.get('/api/admin/artists', { params })
}

/** 证书档案里下拉选择艺人 */
export function artistOptionsApi() {
  return request.get('/api/admin/artists/options')
}

export function artistCreateApi(data) {
  return request.post('/api/admin/artists', data)
}

export function artistUpdateApi(id, data) {
  return request.put(`/api/admin/artists/${id}`, data)
}

export function artistDeleteApi(id) {
  return request.delete(`/api/admin/artists/${id}`)
}
